<script >
import CollapseTransition from './CollapseTransition.vue';
import Icon from './Icon.vue';
import useCssVar from '../composables/useCssVar';
import useSwiper from '../composables/useSwiper';
const __sfc_main = {};
__sfc_main.props = {
  swiperWidth: {
    type: Number,
    default: 250
  },
  swiperHeight: {
    type: Number,
    default: 340
  },
  cardSpacing: {
    type: Number,
    default: 20
  },
  autoplayDelay: {
    type: Number,
    default: 3000
  },
  titleColor: String,
  descColor: String,
  bgActiveColor: String,
  list: {
    type: Array,
    default: () => []
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    use: {
      useLang,
      usePageType
    }
  } = require('@fegobull/webapi');
  const {
    langText
  } = useLang();
  const {
    isPC
  } = usePageType();
  const props = __props;
  const {
    cssVar
  } = useCssVar(props);
  const {
    activeIndex,
    swiperRef,
    slideTo
  } = useSwiper(props);
  return {
    langText,
    isPC,
    cssVar,
    activeIndex,
    swiperRef,
    slideTo
  };
};
__sfc_main.components = Object.assign({
  Icon,
  CollapseTransition
}, __sfc_main.components);
export default __sfc_main;
</script>
<template>
    <div
        ref="tile-swiper-v2"
        :class="[
            'tile-swiper-v2-container',
            theme,
            langText,
            {
                PC: isPC
            }
        ]"
        :style="[cssVar]"
    >
        <div class="img-list" ref="swiperRef">
            <div class="swiper-wrapper">
                <div v-for="(item, i) in list" :key="i" class="swiper-slide">
                    <img class="swiper-item" :src="item.img" :alt="item.alt || ''" />
                </div>
            </div>
        </div>
        <ul class="card-list">
            <li
                v-for="(item, index) in list"
                :key="index"
                :class="[
                    'card-item',
                    {
                        active: activeIndex === index
                    }
                ]"
                @click="slideTo(index)"
            >
                <div class="card-item__head">
                    <p class="card-item__title" v-html="item.title"></p>
                    <Icon class="card-item__icon" :active="activeIndex === index" />
                </div>
                <CollapseTransition v-if="activeIndex === index">
                    <p class="card-item__desc" v-html="item.desc"></p>
                </CollapseTransition>
            </li>
        </ul>
    </div>
</template>
<style lang="less" scoped>
@import './index.less';
</style>
